import UnlockTitle from "./UnlockTitle";
import MPForm from "./MPForm";
import UnlockWith from "./UnlockWith";

const lockComponents = {
  UnlockTitle,
  MPForm,
  UnlockWith
}

export default lockComponents;